import React, { useEffect, useState } from 'react'
import $ from 'jquery'
import jsPDF from "jspdf";
import html2canvas from "html2canvas";


export default function Project_timetracking() {
  const active_pro_name = localStorage.getItem('selected_project_name');
  const [listProjecttimeArray, setListProjecttimeArray] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [totalTime, setTotalTime] = useState(0);
  const [companylogo, setCompanylogo] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [membretype, setMembertype] = useState(false);
  useEffect(() => {
     let memtype = localStorage.getItem('membership_type');
        if (memtype === 'free') {
            setMembertype(true);
        }
    const storedPermissions = JSON.parse(localStorage.getItem('user_permissions')) || [];
    setPermissions(storedPermissions);
    const active_pro_id = localStorage.getItem('selected_project_id');
    setCompanylogo(localStorage.getItem('companylogo'));
    setCompanyName(localStorage.getItem('mem_company_name'));
    fetch('getAllProjectTime.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams({ pro_id: active_pro_id })
    })
      .then(res => res.json())
      .then(data => {
        console.log(data);

        if (Array.isArray(data) && data.length > 0) {
          setListProjecttimeArray(data);
        } else {
          showAlert('Cannot find any Time record for this project.');
          setListProjecttimeArray([]);
        }
      })
      .catch(err => {
        console.error("Fetch Error:", err);
      });
  }, []);

  useEffect(() => {
    let totalSeconds = 0;

    listProjecttimeArray.forEach(item => {
      totalSeconds += timeToSeconds(item.time_worked);
    });

    setTotalTime(totalSeconds);
  }, [listProjecttimeArray]);

  const timeToSeconds = (timeStr) => {
    if (!timeStr) return 0;

    const parts = timeStr.split(':');
    const h = parseInt(parts[0]) || 0;
    const m = parseInt(parts[1]) || 0;
    const s = parseInt(parts[2]) || 0;

    return (h * 3600) + (m * 60) + s;
  };

  const formatTotalTime = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);

    return `${hrs}h ${mins}m`;
  };

  function showAlert(msg) {
    $('#alertpop').css('display', 'block');
    $('#alert_text').text(msg);
  }

  function closeAlert() {
    $('#alertpop').css('display', 'none');
    $('#alert_text').text('');
  }

  const printTimeChart = async () => {
    const input = document.getElementById("timeSheetArea");

    if (!input) {
      console.error("timeSheetArea not found");
      return;
    }

    if (listProjecttimeArray.length === 0) {
      alert("No data to export");
      return;
    }

    try {
      const canvas = await html2canvas(input, {
        scale: 2,
        useCORS: true,
        allowTaint: true
      });

      const imgData = canvas.toDataURL("image/png");

      // 👉 Debug check
      if (!imgData.startsWith("data:image/png")) {
        throw new Error("Invalid image data");
      }

      const pdf = new jsPDF("p", "mm", "a4");

      const imgWidth = 210;
      const pageHeight = 295;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      pdf.save("timesheet.pdf");

    } catch (err) {
      console.error("PDF Error:", err);
    }
  };

  function viewTaskDetails(details){
    document.getElementById('taskdetails').style.display='block';
    document.getElementById('task_text').textContent = details;
  }

  function closeTskdetails(){
    document.getElementById('taskdetails').style.display='none';
    document.getElementById('task_text').textContent = '';
  }
  return (
    <div>
      <div className='topbar_menu'>
        {permissions.includes("timesheet.view_all") && (
          <button className='member_button  addmembtn' onClick={printTimeChart}>Download PDF</button>
        )}
        <p>Project name : {active_pro_name}</p>
        <p>Total time Worked : <span>{formatTotalTime(totalTime)}</span></p>
      </div>
      <div className='member_row'>
        <div className='member_details'>
          <section className='vl_dsh_bodypart_section pos_rel'>
            <div >
              <div className='vl_listing_area' id="timeSheetArea">
                <div className="pdf-header">
                  <div className='fullwidth pull_left bc-vld'><h2 className='pdfheading'>Project Time Report</h2></div>
                  <div className="pdf-header-left">
                    <img src={companylogo} alt="Company Logo" className="pdf-logo" crossOrigin="anonymous" />
                    <span><h2>{companyName}</h2></span>
                  </div>

                  <div className="pdf-header-right pt-15">
                   
                    <p>Date Of Report: {new Date().toLocaleDateString()}</p>
                    <p>Project: {active_pro_name}</p>
                  </div>
                </div>
                <div className='vl_listing_row vl_listing_pdfrow listheading_row'>
                  <div className='vl_listing_cell width25'>
                    <h4 className='prj_name'>Member's Name</h4>
                  </div>
                  <div className='vl_listing_cell width25'>
                    <p>Task Name</p>
                  </div>

                  <div className='vl_listing_cell width15'>
                    <p>Start time</p>
                  </div>
                  <div className='vl_listing_cell width15'>
                    <p>End time</p>
                  </div>
                  <div className='vl_listing_cell width15'>
                    <p>Time Worked</p>
                  </div>
                </div>
                {Array.isArray(listProjecttimeArray) && listProjecttimeArray.map((item, index) => {

                  return (
                    <div className='vl_listing_row'>
                      <div className='vl_listing_cell width25' key={index}>
                        <h4 className='prj_name'>{item.user_name}</h4>
                        <span>Date : {item.dateofWork}</span>
                        <span><button className='startbutton'onClick={() => viewTaskDetails(item.task_details)}>View Task Details</button></span>
                      </div>
                      <div className='vl_listing_cell width25'>
                        <p>{item.task_name}</p>
                      </div>
                      <div className='vl_listing_cell width15'>
                        <p>{item.start_time}</p>
                      </div>
                      <div className='vl_listing_cell width15'>
                        <p>{item.end_time ? item.end_time : 'Running...'}</p>
                      </div>
                      <div className='vl_listing_cell width15'>
                        <p>{item.time_worked}</p>
                      </div>

                    </div>
                  )
                })}
              </div>
            </div>
          </section>
        </div>
      </div>
      <div className='vl_dsh_popup' id="alertpop">
        <div className='alertbox'>
          <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
          <div className='contentarea'>
            <p id="alert_text"></p>
          </div>
          <div className='alert_btns'>
            <button onClick={closeAlert}>Close</button>
          </div>
        </div>
      </div>
       <div className='vl_dsh_popup' id="taskdetails">
        <div className='alertbox bigheight'>
          
          <div className='contentarea'>
            <p id="task_text"></p>
          </div>
          <div className='alert_btns'>
            <button onClick={closeTskdetails}>Okay</button>
          </div>
        </div>
      </div>
       {membretype && (
                <div className='vl_dsh_popup activebillpop'>
                    <div className='alertbox'>
                        <div className='alertheader'>
                            <h3><i className='ri-alert-line'></i>Alert</h3>
                        </div>

                        <div className='contentarea'>
                            <p>Please upgrade your membership to access this page</p>
                        </div>
                         <div className='alert_btns'>
                            <button onClick={() => window.history.back()}>Back</button>
                        </div>

                    </div>
                </div>
            )}
    </div>
  )
}
